import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", null, "Member's accesses", -1)
const _hoisted_2 = {
  key: 0,
  class: "block"
}
const _hoisted_3 = {
  key: 0,
  class: "block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_td = _resolveComponent("q-td")!
  const _component_resource_link = _resolveComponent("resource-link")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_q_table, {
      columns: _ctx.memberAccessesColumns,
      rows: _ctx.memberAccessesList,
      "row-key": "contentAccessId",
      flat: ""
    }, {
      "body-cell-packages": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.packages, (item, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                (_ctx.isPackageAvailable(item.packageId))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.name), 1))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-resourceId": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_resource_link, {
              resource: props.value
            }, null, 8, ["resource"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-resource": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.value.type) + " ", 1),
            (props.value.title)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _createElementVNode("i", null, _toDisplayString(props.value.title), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 1
    }, 8, ["columns", "rows"])
  ], 64))
}